import React from 'react'
import Navbar from "./Navbar"
import ownerData from '../ownerData'
import Pet from "./Pet"
import Owner from './Owner'
import Card from './Card'
import Footer from './Footer'
import "../css/info.css"
import { useState, useEffect } from 'react';
import axios from "axios";
import { useParams } from 'react-router-dom';

function Info() {


  const [filteredPets, setFilteredPets] = useState([]);


  useEffect(() => {
    const fetchPets = async () => {
      try {
        const response = await axios.get('https://petme.onrender.com/api/pets?verified=true');
        setFilteredPets(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPets();
  }, []);






  const params = useParams()
  const petid = params.petid;




  const [pets, setPets] = useState([]);

  useEffect(() => {

    const fetchPets = async () => {
      try {
        const response = await axios.get(`https://petme.onrender.com/api/pets/_id/${petid}`);
        setPets(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchPets();
  }, [petid]);


  return (
    <div className="pet">
      <Navbar
        ownerImg={ownerData[0].ownerImg}
      />
      <section id="pet-info">
        <div class="row info-row">
          <div className="info-box-img">
            {pets && <Pet pets={pets[0]} />}
          </div>
          <div className="info-box-details">

            {pets && <Owner pets={pets} />}
          </div>
        </div>
      </section>

      <div className="info-friend">
        <h2 className="info-forever-friend">Finding Your Forever Friend</h2>
      </div>

      <section id="animal">
        <div class="row">

          {filteredPets.map((pet) => (
            <div key={pet.id} className="animal-box col-lg-3 col-md-4">
              <Card pet={pet} />
            </div>
          ))}
        </div>
      </section>
      <Footer />

    </div>
  )
}

export default Info